<template>
    <div class="container-fluid pt-2">
        <div v-if="queryParams && inventoryVarianceReport">
            <div class="py-2 ">
                <div class="d-flex justify-content-end">
                    <a @click="withVariance()" class="btn btn-sm btn-outline-primary mx-1">{{(withVarianceAll) ? 'Only with Issue' : 'All Listings' }}</a>
                    <a @click="generatePDF" class="btn btn-sm btn-primary mx-1">Download PDF</a>
                    <a @click="adoptAsInventory(inventoryVarianceReport.id)" class="btn btn-sm btn-primary mx-1">Update Inventory

                    </a>
                </div>
            </div>
            <div ref="varianceReportPdf" class="mb-1">
                <h3>Variance Report</h3>
                <hr />
                <h2 class="text-capitalize">Done By: {{ inventoryVarianceReport.done_by.name }}</h2>
                <br/>
                <h2>Date: {{ formatDate(inventoryVarianceReport.created_at,'h:mm a DD-MMM-YYYY') }} </h2>
                <table class="table table-sm table-striped" v-if="withVarianceAll">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Dukakit Count <br><small>(Recorded in the platform)</small></th>
                            <th>Physical Count <br><small>(Currently on shelves)</small></th>
                            <th>Variance <br><small>(Dukakit Count − Physical Count)</small></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in inventoryVarianceReport.current_stock" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.product || 'N/A' }} </td>
                            <td :class="item.remaining_units !== parseInt(item.stockCount) ? 'text-danger' : ''">
                                {{ item.remaining_units ? item.remaining_units : '-' }} - ({{convertCurrencyToLocal(item.remaining_units * item.wholesale_ppu) }})
                            </td>
                            <td :class="item.remaining_units !== parseInt(item.stockCount) ? 'text-danger' : ''">
                                {{ item.stockCount ? item.stockCount + '- (' + convertCurrencyToLocal(item.stockCount * item.wholesale_ppu) +')'  : '-' }}
                            </td>
                            <td>
                                <span :class="item.remaining_units !== parseInt(item.stockCount) ? 'badge badge-danger py-1 px-1' : 'badge badge-secondary py-1 px-1'">
            {{ (item.remaining_units && item.stockCount) ? (item.remaining_units - item.stockCount) + '- (' + convertCurrencyToLocal((item.remaining_units - item.stockCount) * item.wholesale_ppu) +')' : '-' }}
          </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-sm table-striped" v-else>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Remaining Units
                                <p><small>In inventory</small></p>
                            </th>
                            <th>Store Count
                                <p><small>Physical</small></p>
                            </th>
                            <th>Variance
                                <p><small>Inventory (-) In store</small></p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="item.remaining_units !== parseInt(item.stockCount)" v-for="(item, index) in inventoryVarianceReport.current_stock" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.product }}</td>
                            <td :class="item.remaining_units !== parseInt(item.stockCount) ? 'text-danger':''">{{item.remaining_units}} </td>
                            <td :class="item.remaining_units !== parseInt(item.stockCount) ? 'text-danger':''">{{item.stockCount}} </td>
                            <td><span :class="item.remaining_units !== parseInt(item.stockCount) ? 'badge badge-danger py-1 px-1':'badge badge-secondary py-1 px-1'">{{item.remaining_units-item.stockCount}}</span> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="text-left py-3">
                        <h3 class="text-weight-900">Stock Variance Reports</h3>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                            <template #input="picker" style="width: 100% !important;">
                                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                        <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                            </template>
                    </date-range-picker>
                </div>
            </div>
            <div style="margin-bottom: 5em;">
                <table v-if="inventoryVarianceReport.length > 0"  class="table table-sm table-striped">
                    <thead>
                        <td>#</td>
                        <td>Report</td>
                        <td>Done By</td>
                        <td>Date</td>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in inventoryVarianceReport" v-if="item.auto_save == 0">
                            <td><a class="text-dark" :href='"/inventory-variance-report?v_id="+item.id'>{{ index+1 }} </a></td>
                            <td><a class="text-dark" :href='"/inventory-variance-report?v_id="+item.id'>{{ item.variance_title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-variance-report?v_id="+item.id' v-if="item.done_by">{{ item.done_by.name }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-variance-report?v_id="+item.id'>{{formatDate(item.created_at,'h:mm a DD-MM-Y') }}</a></td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                <div class="justify-content-center d-flex align-middle" >
                    <h3>Seems you have no recent stock take for the period selected</h3>

                </div>
                <div class="justify-content-center d-flex align-middle" >

                        <p>{{ formatDate(dateRange.startDate,'DD-MMM-YYYY') }} to {{ formatDate(dateRange.startDate,'DD-MMM-YYYY') }}</p>

                </div>
     <div class="justify-content-center d-flex align-middle" >

                        <p><a href="/stock-take" class="text-primary">You can do stake take</a> or filter you data by date</p>

                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
     import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import html2pdf from 'html2pdf.js'; // Import the html2pdf library
import { result } from 'lodash';
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            DateRangePicker

        },
        data() {
            return {
                inventoryVarianceReport: {
                    done_by: {}
                },
                queryParams: null,
                withVarianceAll: true,
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                 autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
            }
        },
        mounted() {
            this.queryParams = this.getQueryParams('v_id')
            this.getInventoryVariance()
        },
        watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                    this.getInventoryVariance()
                }

            },
        },
        methods: {
            async getInventoryVariance() {
                const urlParams = new URLSearchParams(window.location.search);
                await axios.get('/api/inventory-variance', {
                    params: {
                        id: this.queryParams,
                         startdate: urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),
                    }
                }).then(results => {
                    this.inventoryVarianceReport = results.data.variance
                    this.dateRange.startDate = results.data.startDate
                    this.dateRange.endDate = results.data.endDate

                }).catch(error => {})
            },
            withVariance() {
                this.withVarianceAll = (this.withVarianceAll) ? false : true
            },
            adoptAsInventory()
            {
                this.boxTwo = ''
                this.$bvModal.msgBoxConfirm('Do you want to update your inventory quantities to this? Note this action is irreversible', {
                title: 'Are you sure?',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Continue',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if(value)
                    {

                      axios.post('/api/adopt-inventory',{
                        variance_id: this.getQueryParams('v_id')
                      }).then(result=>{
                        if(result.status===200)
                      {
                        this.$toasts.push(
                            {
                                    type: 'success',
                                    message: "Inventory updated successfully",
                            });
                            setTimeout( ()=>{
                                    // window.location.href='/inventory'
                            },5000)

                        }
                                }).catch(error => {

          this.$toasts.push(
            {
                    type: 'error',
                    message: error
              });
        });
                    }

                })
                .catch(err => {
                    // An error occurred
                })

            },
            generatePDF() {
                // Get the .invoice element to be converted into PDF
                const element = this.$refs.varianceReportPdf;
                // Configuration for html2pdf.js
                const opt = {
                    margin: 10,
                    filename: 'variance_report.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 0.98
                    },
                    html2canvas: {
                        scale: 2
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'portrait'
                    },
                };
                // Generate the PDF using html2pdf.js and trigger the download
                html2pdf().from(element).set(opt).save();
            },
            getQueryParams(toSearch) {
                const params = new URLSearchParams(window.location.search);
                return params.get(toSearch);
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
        },
    }
</script>

<style>
    .list-search-item {
        margin: 0.5em 0 0.5em 0;
        padding: 0;
    }
    small {
        font-size: 11px !important;
    }
    #customdropzone {
        min-width: 320px;
        min-height: 180px;
    }
</style>
